import React from 'react';
import ProductContainer from './ProductContainer';
import Whychoose from './whychoose/Whychoose';
import Howwork from './howworks/Howwork';
import Products from './Products';
import Partners from './Partners.js';
import Getstart from './getstated/Getstart';
import Contact from '../components/Contact.js';

const HomePage = () => {
  return <div>
    <ProductContainer />
    <Whychoose />
    <Howwork />
    <Getstart />
    <Contact />
    <Products />
    <Partners />
  </div>

};

export default HomePage;
